export default __webpack_public_path__ + "static/media/ellip_message.b02eb704.svg";